import { useEffect } from 'react';
import { useAuth } from '../context/AuthContext';

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  return Uint8Array.from([...rawData].map((c) => c.charCodeAt(0)));
}

const usePushNotifications = () => {
  const { user, getToken } = useAuth();

  useEffect(() => {
    if (!user) return;
    if (!('serviceWorker' in navigator) || !('PushManager' in window)) return;

    const setup = async () => {
      try {
        const registration = await navigator.serviceWorker.register('/sw.js');

        const existing = await registration.pushManager.getSubscription();
        if (existing) {
          await sendToServer(existing, getToken());
          return;
        }

        const permission = await Notification.requestPermission();
        if (permission !== 'granted') return;

        const keyRes = await fetch('/api/push/vapid-public-key');
        const { publicKey } = await keyRes.json();
        if (!publicKey) return;

        const subscription = await registration.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: urlBase64ToUint8Array(publicKey),
        });

        await sendToServer(subscription, getToken());
      } catch (err) {
        console.error('Push setup error:', err);
      }
    };

    setup();
  }, [user]);
};

async function sendToServer(subscription, authToken) {
  await fetch('/api/push/subscribe', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${authToken}`,
    },
    body: JSON.stringify({ subscription }),
  });
}

export default usePushNotifications;
